import { Grid, Typography } from "@mui/material";
import type { TransactionStatus } from "Infrastructure/Api/Api";
import { StatusFilterDropdown } from "Components/Transactions/TransactionsSearchBar/TransactionFilters/StatusFilterDropdown";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Shared.Filters;

type Props = {
  value?: TransactionStatus;
  onChange: (value: TransactionStatus | undefined) => void;
};

export const StatusFilter = ({ value, onChange }: Props) => {
  const { t } = useResource();

  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <Typography fontSize={13} fontWeight={400} mb={1}>
        {t(RESOURCES.Status)}
      </Typography>
      <StatusFilterDropdown value={value} onChange={onChange} />
    </Grid>
  );
};
